import Button from 'components/button';
import { useMenu } from 'context/MenuContext';
import { t } from 'i18next';
import { getCurrentProduct } from 'utils/productCookies';
import styles from './styles.module.scss';

function AccountInfo() : JSX.Element {
  const { menu, isUndefined } = useMenu();
  const editAccountUrl = () : string => {
    if(isUndefined())
      return '';

    const currentProductName = getCurrentProduct();
    const currentProduct = menu.applications.filter(x => x.applicationName == currentProductName);

    if(!currentProduct) return '';
    if(!currentProduct[0]) return '';

    return currentProduct[0].editAccountUrl || '';
  };

  return (
    <div id={styles['biobar-account-info']}>
      <p id={styles['biobar-user-name']}>{menu.fullName}</p>
      <p id={styles['biobar-user-email']}>{menu.email}</p>
      {editAccountUrl() !== '' &&
        <a href={`${editAccountUrl()}`}>
          <Button text={t('biobar.profile.manage.button')} outline={true} />
        </a>}
    </div>
  );
}

export default AccountInfo;